// Add paths here if you're going to reference them outside of routes

export const APPRAISER_CUSTOMER_EXCLUSIONS = "appraiser-customer-exclusions";
export const FIELD_REP_CUSTOMER_EXCLUSIONS = "fr-customer-exclusions";